export default __webpack_public_path__ + "static/media/thaivilla.848b8858.jpeg";